(() => {
  document.addEventListener('click', event => {
    const summary = event.target.closest('[data-quick-picker] > summary');
    if (!summary || !window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
    event.preventDefault();
    const details = summary.closest('[data-quick-picker]');
    const form = details.querySelector('[data-quick-add]');
    if (!form) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'bn-quick-dialog';
    dialog.setAttribute('aria-label', form.querySelector('.bn-quick-add__heading').textContent + ' — ' + form.querySelector('.bn-quick-add__product').textContent);
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'bn-quick-dialog__close';
    close.setAttribute('aria-label', form.dataset.close);
    close.textContent = '×';
    dialog.append(close, form);
    document.body.append(dialog);
    details.open = false;
    dialog.addEventListener('close', () => {
      details.append(form);
      dialog.remove();
      if (summary.isConnected) summary.focus();
    }, {once: true});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => {
      if (e.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) dialog.close();
    });
    dialog.showModal();
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-quick-add]');
    if (!form || !window.fetch || !window.FormData || !document.querySelector('[data-bn-bag]')?.showModal) return;
    event.preventDefault();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    const data = new FormData(form);
    if (event.submitter?.name === 'id') data.set('id', event.submitter.value);
    if (!data.get('id')) return;
    const status = form.querySelector('[data-quick-status]');
    const buttons = [...form.querySelectorAll('[type="submit"]')];
    const dialog = form.closest('.bn-quick-dialog');
    form.dataset.busy = 'true';
    form.setAttribute('aria-busy', 'true');
    buttons.forEach(button => { button.disabled = true; });
    status.textContent = form.dataset.adding;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {Accept: 'application/json'}, body: data});
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : form.dataset.error);
      status.textContent = form.dataset.added;
      if (dialog?.open) dialog.close();
      const details = form.closest('[data-quick-picker]');
      if (details) details.open = false;
      document.dispatchEvent(new CustomEvent('bn:cart-added'));
      document.dispatchEvent(new CustomEvent('bn:cart-changed'));
    } catch (error) {
      status.textContent = error.message || form.dataset.error;
    } finally {
      delete form.dataset.busy;
      form.removeAttribute('aria-busy');
      buttons.forEach(button => { button.disabled = false; });
    }
  });
})();
